import React from 'react';
import { Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const ContactButton = ({ 
  size = "md", 
  variant = "solid", 
  bg = "#094c26", 
  color = "white",
  children = "Contactez-nous",
  ...props 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    // Scroll vers le haut de la page après navigation
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <Button
      bg={bg}
      color={color}
      size={size}
      fontWeight="bold"
      borderRadius="full"
      px={6}
      py={3}
      _hover={{ bg: '#0d6b35', transform: "scale(1.05)" }}
      transition="all 0.2s"
      boxShadow="0 4px 14px 0 rgba(9, 76, 38, 0.3)"
      onClick={handleClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ContactButton;
